// Keep the mobile product information unobstructed; the chat panel itself is untouched.
(() => {
  if (window.gadcetProductViewportInstalled || !('IntersectionObserver' in window)) return;
  window.gadcetProductViewportInstalled = true;
  let observer;
  const connect = () => {
    if (observer) observer.disconnect();
    const boxes = [...document.querySelectorAll('.psgl-ly-2 .product-info')];
    const visible = new Set();
    const update = () => document.body.classList.toggle('gdc-buybox-in-view', visible.size > 0);
    boxes.forEach(box => {
      const rect = box.getBoundingClientRect();
      if (rect.width && rect.bottom > 0 && rect.top < window.innerHeight) visible.add(box);
    });
    update();
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
      update();
    });
    boxes.forEach(box => observer.observe(box));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, {once: true});
  else connect();
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('shopify:section:unload', connect);
})();
